const meetingminutes = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Meeting Minutes',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4",
                "children": [
                    {
                        "title": "Meeting Minutes",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": true,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Item",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "variant": "add",
                                "form": {
                                    "title": {
                                        "type": 'text',
                                        "label": 'Name',
                                        "placeholder": 'Enter Name',
                                        "required": true,
                                        "info": true,
                                        "character_count": 50,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "date": "",
                                    "file_url": "",
                                    // "slug": "",
                                    // "media_type":"None",
                                    // "image_url":"",
                                    // "video_url":"",
                                    // "upload_type": "",
                                    // "upload_url": "",
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "memberPracticesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Select a Title",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ],
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "",
                                    "class": "pl-4 pt-3",
                                    "submit_url": "/api/pages/$currentPageId",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Event Title',
                                            "placeholder": 'Enter Practice Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "date": {
                                            "type": 'date',
                                            "label": 'Select Date',
                                            "placeholder": 'Select Date',
                                            "required": true,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "file_url": {
                                            "type": 'text',
                                            "label": 'File URL Title',
                                            "placeholder": 'Enter File URL',
                                            "required": true,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        }
                                    },
                                    "children": [
                                    ]
                                }
                            }
                        ]
                    }
                ]
            },

        ]
    }
]

export { meetingminutes };